/* global Language, Sys, Services */
Sys.ns("Services");

/**
 * The Language Service.
 *
 * @class Services.Language
 * @extends Services.Base
 */
Services.Language = {
    constructor: function() {
        Services.Language.superclass.constructor.apply(this, arguments);
    },

    /**
     * Tells if LanguageManager has the text string or not.
     *
     * @param {string|number} id The text id.
     * @returns {boolean} True if found, false otherwise.
     */
    hasText: function(id) {
        return Services.languageManager.hasText(id);
    },

    /**
     * Gets the translated text associated with the id.
     *
     * @param {string} id The text id.
     * @param {Array} [values] The values to add to the string template.
     * @returns {string} The translated text associated with the id.
     */
    getText: function(id, values) {
        return Services.languageManager.getText(id, values);
    },

    /**
     * Gets the language keys.
     *
     * @returns {Object} The object containing the language keys.
     */
    getKeys: function() {
        return Language.Keys;
    }
};

Services.Language = Sys.extend(
    Services.Base,
    Services.Language,
    "Services.Language"
);
